




















import { Component, Prop, Vue } from "vue-property-decorator";
import { CookieHelper } from "@/helper/cookieHelper";

@Component({
  components: {
  }
})

export default class IeAlertModal extends Vue {

    private close(){
        CookieHelper.setItem("ieAlertShown", true);
        this.$emit('close');
    }

    private get userConfigButtonColorStyle(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
}
